import React, { useRef, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash} from '@fortawesome/free-solid-svg-icons';
import './Training.css';



function EditQuestions(arg) {
  console.log(arg.data);
  const [show, setShow] = useState(arg.flag);
 
  const handleClose = () => {
    setShow(false);
    arg.handler();
  }

  const deleteTQuesion=(id)=>{
     setShow(false);
    arg.deleteCB(id);
  }
  const handleShow = () => setShow(true);
  
  return (
    <>
      <Modal show={show} onHide={handleClose}  backdrop="static" keyboard={false} size='lg'>
        <Modal.Header>
          <Modal.Title>Edit Questions</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <ul className='qstn-list'>
              {
                arg.data && arg.data.map((element,index) => {
                  console.log("here");
                  return(
                    <li key={index}>
                      <div className='qtn-box'>
                        <div>
                          <span>ID : {" "+element.id}</span>
                          <button type='button' className='btn btn-danger' onClick={()=>deleteTQuesion(element.id)}><FontAwesomeIcon icon={faTrash} className='table-icon-inline'/>Delete</button>
                        </div>
                        <div>Question : {" "+element.question}</div>
                        <div>Description : {" "+element.description}</div>
                        <div>
                          <a href={element.image1} target='_blank'>Image 1</a><span>{"   "}</span>
                          <a href={element.image2} target='_blank'>Image 2</a>
                        </div>
                        <div>Image-1 Details : {" "+element.image1Description}</div>
                        <div>Image-2 Details : {" "+element.image2Description}</div>
                      </div>
                    </li>
                  )
                })
              }
            </ul>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            CANCEL
          </Button>
         
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default EditQuestions;

